if(typeof BSS_B2B != undefined) {
  if(!window.location.pathname.includes("/products/")) {
    setTimeout(() =>{
      let quickViewBtn = document.querySelectorAll('.quick-product__btn');
      if (quickViewBtn.length) {
          for (let i = 0; i < quickViewBtn.length; i++) {
              quickViewBtn[i].onclick = function () {
                  setTimeout(function () {
                      document.dispatchEvent(new Event("bss_b2b:QuickviewLoaded"))
                  }, 1500);
              }
          }
      }
    }, 3000)
  }
}